import(/* webpackMode: "eager" */ "/home/runner/work/DLOM/DLOM/frontend/app/calculator/page.tsx");
